// Bounded container evidence, not a decoder or an intelligibility test. In
// particular, Safari can emit a nonempty five-byte blob without audio frames.
export class AutotranslatorAudioEvidence {
    bytes = 0;
    private header: number[] = [];
    private tail = new Uint8Array();
    private clusterStart = Infinity;
    private mediaEnd = Infinity;
    private media = false;
    constructor(private mime: string) {}

    async inspect(blob: Blob): Promise<void> {
        if (this.media && this.header.length === 8) { this.bytes += blob.size; return; }
        const chunk = new Uint8Array(await blob.arrayBuffer());
        const before = this.bytes;
        this.bytes += chunk.length;
        this.header.push(...chunk.subarray(0, Math.max(0, 8 - this.header.length)));
        const bytes = new Uint8Array(this.tail.length + chunk.length);
        bytes.set(this.tail); bytes.set(chunk, this.tail.length);
        const starts = (at: number, signature: number[]) => signature.every((value, offset) => bytes[at + offset] === value);
        for (let i = 0; i < bytes.length; i++) {
            const absolute = before - this.tail.length + i;
            if (this.mime.startsWith("audio/webm")) {
                if (starts(i, [0x1f, 0x43, 0xb6, 0x75])) this.clusterStart = Math.min(this.clusterStart, absolute + 4);
                // A SimpleBlock/Block within a Cluster contains track, timecode,
                // flags and encoded payload. Keep enough lookahead for them.
                if (absolute >= this.clusterStart && (bytes[i] === 0xa3 || bytes[i] === 0xa1) && i + 6 < bytes.length) this.media = true;
            } else if (this.mime.startsWith("audio/mp4")) {
                if (starts(i, [0x6d, 0x64, 0x61, 0x74])) this.mediaEnd = Math.min(this.mediaEnd, absolute + 4);
                if (this.bytes > this.mediaEnd) this.media = true;
            } else if (starts(i, [0x4f, 0x67, 0x67, 0x53]) && i + 27 < bytes.length) {
                const segments = bytes[i + 26], payload = i + 27 + segments;
                const payloadSize = bytes.subarray(i + 27, payload).reduce((sum, size) => sum + size, 0);
                if (segments && payloadSize && payload + Math.min(8, payloadSize) <= bytes.length && !starts(payload, [79, 112, 117, 115, 72, 101, 97, 100]) &&
                    !starts(payload, [79, 112, 117, 115, 84, 97, 103, 115])) this.media = true;
            }
            if (this.media) break;
        }
        if (this.bytes > this.mediaEnd) this.media = true;
        this.tail = this.media ? new Uint8Array() : bytes.slice(-512);
    }

    get valid(): boolean {
        const h = this.header;
        const starts = (at: number, signature: number[]) => signature.every((value, offset) => h[at + offset] === value);
        const header = this.mime.startsWith("audio/webm") ? starts(0, [0x1a, 0x45, 0xdf, 0xa3]) :
            this.mime.startsWith("audio/mp4") ? starts(4, [0x66, 0x74, 0x79, 0x70]) : starts(0, [0x4f, 0x67, 0x67, 0x53]);
        return h.length === 8 && header && this.media;
    }
}
